import React, { useCallback, useEffect, useRef, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, Estado, Fornecedor, GrupoDespesa, InputsRefs, NFEntraItem, NFEntrada, NFFilter, ParcelamentoDupPagar, RegimeTributarioType, RetAPI, SubGrupoDespesa, Transportadora, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark,
    classBt, classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classbtAzul, classbtAzulEscuro, classbtCinzaClaro, classbtColunasAzul, classbtVerde, classbtVermelho, focusLabelRed, focusRed
} from "../../Utils/Types"
import { faFilter, faFolder, faMoneyBillAlt, faTable, faTruck } from "@fortawesome/free-solid-svg-icons"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { Icone } from "../../Components/Icones/Index"
import { DataSearch, SearchBox } from "../../Components/SearchBox/SearchBox"
import { Funcoes } from "../../Utils/Funcoes"
import { FaCheck, FaFileDownload, FaRegQuestionCircle, FaTrash, FaTrashAlt } from "react-icons/fa"
import { AttributesNFEntrada, NotaEntradaService } from "./NotaEntradaService"
import { UtilServices } from "../../Utils/UtilServices"
import moment from "moment"
import { ModalLancaItemNF } from "../../Components/Modal/modal-lanca-item-nf"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { Tooltip } from "react-tooltip"
import { IoAddCircleSharp, IoSave, IoSearch } from "react-icons/io5"
import { ModalExcluirDados } from "../../Components/Modal/ModalExcluirDados"
import { GridEntradaNota } from "../../Components/GridProducts/GridNotaEntrada"
import { GridEntradaNotaItem } from "../../Components/GridProducts/GridNotaEntradaItem"
import { AiOutlineClear } from "react-icons/ai"
import { LuFileCheck } from "react-icons/lu"
import { ToolTips } from "../../Components/ToolTips/tooltips"

type Tab = {
    index: number,
    titulo: String,
    active: boolean,
    icon: IconProp,
}

type Item = {
    nitem: number,
    descricao: string,
    qtd: number,
    unit: number,
    vTot: number,
    pIcms: number,
    cfop: number,
}

type Relatorio = {
    datai: string
    dataf: string
    idFornecedorFilter: number
    status: string
}



export const EntradaNotaPage = () => {

    // States sem uso --------------------------------------------------------------------
    /*
    //const [pagesItens, setPagesItens] = useState<number[]>([])
    //const [pagesNF, setPagesNF] = useState<number[]>([])
    //const [currentPage, setCurrentPage] = useState(1)
    //const [exibirItens, setExibirItens] = useState("10")
    //const [NFListCopy, setNFListCopy] = useState<NFFilter[]>([])
    //const [attributes, setAttributes] = useState<AttributesNFEntrada>()
    //const [fornecDataSearch, setFornecDataSearch] = useState<DataSearch[]>([])
    //const [transpDataSearch, setTranspDataSearch] = useState<DataSearch[]>([])
    //const [endeTransp, setEndeTransp]     = useState("")
    //const [CNPJTransp, setCNPJTransp]     = useState("")
    //const [idUf, setIdUf]                 = useState(0)
    //const [uf, setUf]                     = useState<Estado[]>([])
    //const [attuf, setAttUf] = useState<Estado[]>([])
    //const [statusBtFilter, setStatusBtFilter] = useState(false)
    //const [natOp, setNatOp] = useState("")
    //const [produtosList, setProdutosList] = useState<Produto[]>([])
    //const [cfopList, setCfopList] = useState<CFOP[]>([])
    */


    // Variaveis para pegar a data atual e a data daqui a 31 dias
    let dateI = moment().utcOffset('-03:00').format('YYYY-MM-DD')
    let dateF = moment().utcOffset('-03:00').add(31, 'days').format('YYYY-MM-DD')

    // GUIA STATES -----------------------------------------------------------------------
    const itabs: Tab[] = [
        { index: 0, titulo: 'Principal', active: true, icon: faFolder },
        { index: 1, titulo: 'Produtos', active: false, icon: faTable },
        { index: 2, titulo: 'Imposto', active: false, icon: faMoneyBillAlt },
        { index: 3, titulo: 'Frete/Transportadora', active: false, icon: faTruck },
        { index: 4, titulo: 'Duplicatas a Pagar', active: false, icon: faTruck },
        { index: 5, titulo: 'Filtros', active: false, icon: faFilter },
    ]

    const itabsMei: Tab[] = [
        { index: 0, titulo: 'Principal', active: true, icon: faFolder },
        { index: 1, titulo: 'Produtos', active: false, icon: faTable },
        { index: 2, titulo: 'Duplicatas a Pagar', active: false, icon: faTruck },
        { index: 3, titulo: 'Filtros', active: false, icon: faFilter },
    ]

    const [tabsMei, setTabsMei] = useState<Tab[]>(itabsMei)
    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // PRODUTOS STATES --------------------------------------------------------------------
    const [produtos, setProdutos] = useState<NFEntraItem[]>([])
    const [produtosListCopy, setProdutosListCopy] = useState<NFEntraItem[]>([])

    // NF STATES ---------------------------------------------------------------------------
    const [NFList, setNFList] = useState<NFFilter[]>([])

    // ATTRIBUTOS STATES --------------------------------------------------------------------
    const [attributesNFEntrada, setAttributesNFEntrada] = useState<AttributesNFEntrada>({ fornecedores: [], grupoDespesa: [], subgrupoDespesa: [], transportadoras: [], produtos: [], cfops: [], regimeTributario: "MEI", naturezas: [], csts: [] })
    const [fornecedores, setFornecedores] = useState<Fornecedor[]>([])
    const [fornecedoresFilter, setFornecedoresFilter] = useState<Fornecedor[]>([])
    const [fornecedorDupPagar, setFornecedorDupPagar] = useState<Fornecedor[]>([])
    const [grupoDespListDupPagar, setGrupoDespListDupPagar] = useState<GrupoDespesa[]>([])
    const [subGrupoDespListDupPagar, setSubGrupoDespListDupPagar] = useState<SubGrupoDespesa[]>([])
    const [transportadoras, setTransportadoras] = useState<Transportadora[]>([])
    const [parcelamentoList, setParcelamentoList] = useState<ParcelamentoDupPagar[]>([])

    const [naturezas, setNaturezas] = useState<DataSearch[]>([])
    const [regimeTributario, setRegimeTributario] = useState<RegimeTributarioType>("SN")

    // INPUT STATES ---------------------------------------------------------------------------
    // ABA 1
    const [idNF, setIdNF] = useState<number>(0)
    const [numNF, setNumNF] = useState("")
    const [dtEmissao, setDtEmissao] = useState("")
    const [dtChegada, setDtChegada] = useState("")
    const [idFornecedor, setIdFornecedor] = useState<number>(0)
    const [idNatOp, setIdNatOp] = useState<number>(0)
    const [pagamento, setPagamento] = useState("0")
    const [modelo, setModelo] = useState("")
    const [serie, setSerie] = useState("")
    const [finNFe, setFinNFe] = useState("1")
    const [vlProdutos, setVlProdutos] = useState("0,00")
    const [vlNF, setVlNF] = useState("0,00")

    // ABA 3
    const [vlDesc, setVlDesc] = useState("0,00")
    const [vlFrete, setVlFrete] = useState("0,00")
    const [vlSeguro, setVlSeguro] = useState("0,00")
    const [vlOutros, setVlOutros] = useState("0,00")
    const [vlIpi, setVlIpi] = useState("0,00")
    const [vlBcIcms, setVlBcIcms] = useState("0,00")
    const [vlIcms, setVlIcms] = useState("0,00")
    const [vlBcSt, setVlBcSt] = useState("0,00")
    const [vlSt, setVlSt] = useState("0,00")
    const [vlPis, setVlPis] = useState("0,00")
    const [vlCofins, setVlCofins] = useState("0,00")

    // ABA 4
    const [modFrete, setModFrete] = useState("9")
    const [idTransp, setIdTransp] = useState(0)

    // ABA 6 
    const [idDupPagar, setIdDupPagar] = useState(0)
    const [numDocDupPagar, setNumDocDupPagar] = useState("")
    const [serieDupPagar, setSerieDupPagar] = useState("")
    const [valorDupPagar, setValorDupPagar] = useState("0")
    const [idFornecedorDupPagar, setIdFornecedorDupPagar] = useState(0)
    const [idGrupoDespDupPagar, setIdGrupoDespDupPagar] = useState(0)
    const [idSubGrupoDespDupPagar, setIdSubGrupoDespDupPagar] = useState(0)
    const [dtEmissaoDupPagar, setDtEmissaoDupPagar] = useState(dateI)
    const [dtVencimentoDupPagar, setDtVencimentoDupPagar] = useState("")
    const [observacaoDupPagar, setObservacaoDupPagar] = useState("")
    const [nomeFornecedorDupPagar, setNomeFornecedorDupPagar] = useState("")
    const [loadingDupPagar, setLoadingDupPagar] = useState(false)

    // ABA 7
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [status, setStatus] = useState<string>("N")
    const [idFornecedorFilter, setIdFornecedorFilter] = useState<number>(0)
    const [relatorio, setRelatorio] = useState<Relatorio>({ datai: '', dataf: '', idFornecedorFilter: 0, status: 'N' })

    // MODALS --------------------------------------------------------------------------------------
    const [visibleModalItens, setVisibleModalItens] = useState<boolean>(false)

    // ATRIBUTOS EXCLUSÃO --------------------------------------------------------------------------
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [idNItemExcluir, setIdNItemExcluir] = useState(0)
    const [nomeExcluir, setNomeExcluir] = useState("")

    // FEEDBACK ------------------------------------------------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [visible, setVisible] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")


    // CONDIÇÕES DE NF -----------------------------------------------------------------------------
    const [nfConfirmada, setNFConfirmada] = useState(false)
    const [nitemNF, setNitemNF] = useState<number>(0)

    // SEARCHBOX ----------------------------------------------------------------------------------
    const [visibleSearchBoxForn, setVisibleSearchBoxForn] = useState<boolean>(false)
    const [visibleSearchBoxNatOp, setVisibleSearchBoxNatOp] = useState<boolean>(false)
    const [visibleSearchBoxTransp, setVisibleSearchBoxTransp] = useState<boolean>(false)
    const [visibleSearchBoxFornFiltro, setVisibleSearchBoxFornFiltro] = useState<boolean>(false)
    const [visibleSearchBoxFornecedorDupPagar, setVisibleSearchBoxFornecedorDupPagar] = useState<boolean>(false)
    const [visibleSearchBoxGrupoDespesaDupPagar, setVisibleSearchBoxGrupoDespesaDupPagar] = useState<boolean>(false)
    const [visibleSearchBoxSubGrupoDespesaDupPagar, setVisibleSearchBoxSubGrupoDespesaDupPagar] = useState<boolean>(false)

    // DADOS EMPRESA ----------------------------------------------------------------------------------
    const dadosEmpresa = Funcoes.GetDadosEmpresa()
    const regTrib = dadosEmpresa?.regime_tributario || ''

    //------------------------------------------------------------------------------------------ REQUISIÇÃO API, ATALHOS E USEEFFECT ---------------------------------------------------------------------//
    /*
   useEffect(() => {
       //initializeProdutos()
       //calcQtdPages(produtos.length, parseInt(exibirItens))
       //calcQtdPagesNF(NFList.length, parseInt(exibirItens))
       //filtrarItens()
       //filtrarNotaFiscal()
   }, [])

   useEffect(() => {

       if (produtos) {
           calcQtdPages(produtos.length, parseInt(exibirItens))
           filtrarItens()
       }

       if (NFList) {
           calcQtdPages(NFList.length, parseInt(exibirItens))
           //filtrarNotaFiscal()
       }

       setCurrentPage(1)

   }, [exibirItens])
   */

    /*
    const mapAttributesToDataSearch = (items: any[]) => {
        return items.map((item) => ({
            id: item.id,
            description: item.nome || item.razao
        }))
    }
    */

    const GetAttributes = async () => {

        setVisible(false)
        setLoading(true)

        try {


            const attributes = await NotaEntradaService.GetAttributes()

            setAttributesNFEntrada(attributes.data)
            setRegimeTributario(attributes.data.regimeTributario)
            setNaturezas(attributes.data.naturezas)

            setTransportadoras(attributes.data.transportadoras)
            setFornecedores(attributes.data.fornecedores)
            setFornecedoresFilter(attributes.data.fornecedores)
            setFornecedorDupPagar(attributes.data.fornecedores)

            //const attEstados = await UtilServices.GetCidadeEstado() 
            //setAttUf(attEstados.estados)
            //setUf(attEstados.estados)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as informações`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }

        //setProdutosList(attributes.produtos)
        //setCfopList(attributes.cfops)
        //setFornecDataSearch(await mapAttributesToDataSearch(attributes.fornecedores))
        //setTranspDataSearch(await mapAttributesToDataSearch(attributes.transportadoras))
    }

    useEffect(() => {
        GetAttributes()
    }, [])

    // -------------------------------------------------------------------------
    // INPUTS ABA 1 ------------------------------------------------------------
    // -------------------------------------------------------------------------
    const handleChangeNumNF = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumNF(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeDtEmissao = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtEmissao(e.target.value)
    }

    const handleChangeDtChegada = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtChegada(e.target.value)
    }

    // FORNECEDOR ABA 1 --------------------------------------------------------------
    const handleClearFornSelecionado = useCallback(async () => {

        /*
        const newFornecDataSearch = fornecedores.map((item) => {
            return {
                id: item.id,
                description: item.nome
            }
        })
        */

        const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
        setFornecedores(newFornecedorList || [])
        setIdFornecedor(0)

        setVisibleSearchBoxForn(false)
        boxFocusForn()

    }, [attributesNFEntrada.fornecedores])

    const handleFilterFornecedores = useCallback(async (description: string) => {

        if (description === "") {

            /*
            const newFornecDataSearch = await fornecedores.map((item) => {
                return {
                    id: item.id,
                    description: item.nome
                }
            })
            */
            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedores(newFornecedorList || [])

        } else {

            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedores(newFornecedorList || [])
        }
    }, [attributesNFEntrada.fornecedores])

    const handleClickSelectFornecedor = useCallback((data: DataSearch) => {

        /*
        const newFornecDataSearch = fornecedores.map((item) => {
            return {
                id: item.id,
                description: item.nome
            }
        })
        */

        if (data) {
            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedores(newFornecedorList || [])
            setIdFornecedor(data.id)
            setNomeFornecedorDupPagar(data.description)
        }

        setVisibleSearchBoxForn(false)
        boxFocusForn()

    }, [attributesNFEntrada.fornecedores])
    // -------------------------------------------------------------------------------

    const handleChangePagamento = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPagamento(e.target.value)
    }

    const handleChangeModelo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setModelo(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeSerie = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSerie(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeFinNFe = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFinNFe(e.target.value)
    }

    // NATUREZA DE OPERAÇÃO ----------------------------------------------------
    const handleClearNatOpSelecionado = useCallback(async () => {

        const newNatOpList = [...attributesNFEntrada?.naturezas || []]
        setNaturezas(newNatOpList || [])
        setIdNatOp(0)

        setVisibleSearchBoxNatOp(false)
        boxFocusNatOp()
    }, [attributesNFEntrada.naturezas])

    const handleFilterNatOp = useCallback((description: string) => {

        if (description === "") {

            const newNatOpList = [...attributesNFEntrada?.naturezas || []]
            setNaturezas(newNatOpList || [])
        } else {

            const newNatOpList = [...attributesNFEntrada?.naturezas || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setNaturezas(newNatOpList || [])
        }
    }, [attributesNFEntrada.naturezas])

    const handleClickSelectNatOp = useCallback((data: DataSearch) => {

        if (data) {
            const newNatOpList = [...attributesNFEntrada?.naturezas || []]
            setNaturezas(newNatOpList)
            setIdNatOp(data.id)
        }

        setVisibleSearchBoxNatOp(false)
        boxFocusNatOp()
    }, [attributesNFEntrada.naturezas])
    // -------------------------------------------------------------------------

    const handleGhangeVlProdutos = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlProdutos(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlNF = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlNF(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    // -------------------------------------------------------------------------------
    // INPUTS ABA 3 ------------------------------------------------------------------
    // -------------------------------------------------------------------------------
    const handleGhangeVlDesconto = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlDesc(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlFrete = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlFrete(Funcoes.numberFormat(inputValue, 'decimal'))
    } 

    const handleGhangeVlSeguro = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlSeguro(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlOutros = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlOutros(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlIpi = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlIpi(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlBcIcms = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlBcIcms(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlIcms = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlIcms(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlBcSt = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlBcSt(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlSt = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlSt(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlPis = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlPis(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleGhangeVlCofins = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlCofins(Funcoes.numberFormat(inputValue, 'decimal'))
    }


    // -------------------------------------------------------------------------------
    // INPUTS ABA 4 ------------------------------------------------------------------
    // -------------------------------------------------------------------------------
    const handleChangeModFrete = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const freteOptions = ["0", "1", "2", "9"]

        if (freteOptions.includes(e.target.value)) {
            setModFrete(e.target.value)
        }
    }

    // TRANSPORTADORA ----------------------------------------------------------------
    const handleClearTranspSelecionada = useCallback(() => {
        const newTranspList = [...attributesNFEntrada?.transportadoras || []]
        setTransportadoras(newTranspList)
        setIdTransp(0)

        setVisibleSearchBoxTransp(false)
        boxFocusTransp()

    }, [attributesNFEntrada.transportadoras])

    const handleFilterTransp = useCallback(async (description: string) => {
        if (description === "") {

            const newTranspList = [...attributesNFEntrada?.transportadoras || []]
            setTransportadoras(newTranspList)

        } else {

            const newTranspList = await [...attributesNFEntrada?.transportadoras || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setTransportadoras(newTranspList)
        }
    }, [attributesNFEntrada.transportadoras])

    const handleClickSelectTransp = useCallback((data: DataSearch) => {
        if (data) {
            const newTranspList = [...attributesNFEntrada?.transportadoras || []]
            setTransportadoras(newTranspList)
            setIdTransp(data.id)
        }

        setVisibleSearchBoxTransp(false)
        boxFocusTransp()

    }, [attributesNFEntrada.transportadoras])
    // ------------------------------------------------------------------------------

    // ------------------------------------------------------------------------------
    // INPUTS ABA 6 -----------------------------------------------------------------
    // ------------------------------------------------------------------------------

    const handleChangeNumDocDupPagar = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumDocDupPagar(e.target.value)
    }

    const handleChangeSerieDupPagar = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSerieDupPagar(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeValorDupPagar = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!nomeFornecedorDupPagar){
            let newFornecedoresList = attributesNFEntrada.fornecedores
            newFornecedoresList = newFornecedoresList.filter( item => item.id === idFornecedor )
            if (newFornecedoresList.length > 0){
                setNomeFornecedorDupPagar(newFornecedoresList[0].description)
            }
        }
        
        setValorDupPagar(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeDtEmissaoDupPagar = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtEmissaoDupPagar(e.target.value)
    }

    const handleChangeDtVencimentoDupPagar = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtVencimentoDupPagar(e.target.value)
    }

    const handleChangeObsDupPagar = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacaoDupPagar(e.target.value)
    }

    // FORNECEDOR ABA 6 --------------------------------------------------------------------
    const handleClearFornecedorSelecionadaDupPagar = useCallback(() => {
        /*
        const newFornList = [...attributesNFEntrada?.fornecedores || []]
        setFornecedorDupPagar(newFornList || [])
        setIdFornecedorDupPagar(0)

        setVisibleSearchBoxFornecedorDupPagar(false)
        boxFocusFornecedorDupPagar()
        */
    }, [attributesNFEntrada.fornecedores])

    const handleFilterFornecedorClickDupPagar = useCallback(async (description: string) => {
        /*
        if (description === "") {

            const newFornList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedorDupPagar(newFornList || [])

        } else {

            const newFornList = [...attributesNFEntrada.fornecedores || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedorDupPagar(newFornList || [])
        }
            */

    }, [attributesNFEntrada.fornecedores])

    const handleFornecedorSelectClickDupPagar = useCallback((v: Fornecedor) => {
        /*
        if (v) {
            const newFornList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedorDupPagar(newFornList)
            setIdFornecedorDupPagar(v.id)
        }

        setVisibleSearchBoxFornecedorDupPagar(false)
        boxFocusFornecedorDupPagar()
        */
    }, [attributesNFEntrada.fornecedores])

    //GRUPO DESPESA ABA 6 -------------------------------------------------------------------- 
    const handleClearGrupoDespSelecionadaDupPagar = useCallback(() => {
        const newGrupoDespList = [...attributesNFEntrada?.grupoDespesa || []]
        setGrupoDespListDupPagar(newGrupoDespList)
        setIdGrupoDespDupPagar(0)
        setIdSubGrupoDespDupPagar(0)

        setVisibleSearchBoxGrupoDespesaDupPagar(false)
        boxFocusSubGrupoDespesaDupPagar() // geralmente era pra ficar no boxFocusGrupoDespesaDupPagar() mas como o subgrupoDespesa fica desabilitado e tive que alterar assim para a logica fazer sentido
    }, [attributesNFEntrada.grupoDespesa])

    const handleFilterGrupoDespClickDupPagar = useCallback(async (description: string) => {

        if (description === "") {

            const newGrupoDespList = [...attributesNFEntrada?.grupoDespesa || []]
            setGrupoDespListDupPagar(newGrupoDespList || [])

        } else {

            const newGrupoDespList = [...attributesNFEntrada?.grupoDespesa || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setGrupoDespListDupPagar(newGrupoDespList || [])
        }

    }, [attributesNFEntrada.grupoDespesa])

    const handleGrupoDespSelectClickDupPagar = useCallback((v: GrupoDespesa) => {

        if (v) {
            const newGrupoDespList = [...attributesNFEntrada?.grupoDespesa || []]
            setGrupoDespListDupPagar(newGrupoDespList)
            setIdGrupoDespDupPagar(v.id)
        }

        setVisibleSearchBoxGrupoDespesaDupPagar(false)
        boxFocusGrupoDespesaDupPagar()
    }, [attributesNFEntrada.grupoDespesa])

    //SUBGRUPO DESPESA ABA 6 -------------------------------------------------------------------- 
    const handleClearSubGrupoDespSelecionadaDupPagar = useCallback(() => {
        const newSubGrupoDespList = [...attributesNFEntrada?.subgrupoDespesa || []]
        setSubGrupoDespListDupPagar(newSubGrupoDespList)
        setIdSubGrupoDespDupPagar(0)

        setVisibleSearchBoxSubGrupoDespesaDupPagar(false)
        boxFocusSubGrupoDespesaDupPagar()

    }, [attributesNFEntrada.subgrupoDespesa, grupoDespListDupPagar])

    const handleFilterSubGrupoDespClickDupPagar = useCallback((description: string) => {

        if (description === "") {

            const newSubGrupoDespList = [...attributesNFEntrada?.subgrupoDespesa || []]
            setSubGrupoDespListDupPagar(newSubGrupoDespList)

        } else {

            const newSubGrupoDespList = [...attributesNFEntrada?.subgrupoDespesa || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setSubGrupoDespListDupPagar(newSubGrupoDespList)
        }
    }, [attributesNFEntrada.subgrupoDespesa, grupoDespListDupPagar])

    const handleSubGrupoDespSelectClickDupPagar = useCallback((v: SubGrupoDespesa) => {

        if (v) {
            const newSubGrupoDespList = [...attributesNFEntrada?.subgrupoDespesa || []]
            setSubGrupoDespListDupPagar(newSubGrupoDespList)
            setIdSubGrupoDespDupPagar(v.id)
        }

        setVisibleSearchBoxSubGrupoDespesaDupPagar(false)
        boxFocusSubGrupoDespesaDupPagar()

    }, [attributesNFEntrada.subgrupoDespesa, grupoDespListDupPagar])

    // ------------------------------------------------------------------------------
    // INPUTS ABA 7 -----------------------------------------------------------------
    // ------------------------------------------------------------------------------
    useEffect(() => {
        setNFList([])
        //setNFListCopy([])
    }, [status])

    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatus(e.target.value)
    }

    // FORNECEDOR ABA 7 --------------------------------------------------------------------
    const handleClearFornSelecionadoFilter = useCallback(async () => {

        /*
        const newFornecDataSearch = fornecedores.map((item) => {
            return {
                id: item.id,
                description: item.nome
            }
        })
        */

        const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
        setFornecedoresFilter(newFornecedorList || [])
        setIdFornecedorFilter(0)

        setVisibleSearchBoxFornFiltro(false)
        boxFocusFornFiltro()
    }, [attributesNFEntrada.fornecedores])

    const handleFilterFornecedoresFilter = useCallback(async (description: string) => {

        if (description === "") {

            /*
            const newFornecDataSearch = await fornecedores.map((item) => {
                return {
                    id: item.id,
                    description: item.nome
                }
            })
            */
            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedoresFilter(newFornecedorList || [])
        } else {

            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedoresFilter(newFornecedorList || [])
        }
    }, [attributesNFEntrada.fornecedores])

    const handleClickSelectFornecedorFilter = useCallback((data: DataSearch) => {

        /*
        const newFornecDataSearch = fornecedores.map((item) => {
            return {
                id: item.id,
                description: item.nome
            }
        })
        */

        if (data) {
            const newFornecedorList = [...attributesNFEntrada?.fornecedores || []]
            setFornecedoresFilter(newFornecedorList || [])
            setIdFornecedorFilter(data.id)
        }

        setVisibleSearchBoxFornFiltro(false)
        boxFocusFornFiltro()

    }, [attributesNFEntrada.fornecedores])
    // ------------------------------------------------------------------------------------

    // ------------------------------------------------------------------------------------
    // FUNCOES DE GUIAS -------------------------------------------------------------------
    // ------------------------------------------------------------------------------------
    const handleChangeTab = async (tab: number) => {
        const newTabs = await tabs.map((aba: Tab, index: number) => {
            itabs[index].active = itabs[index].index === tab
            return itabs[index]
        })
        setTabs(newTabs)
        setVisibleSearchBoxForn(false)
        setVisibleSearchBoxNatOp(false)
        setVisibleSearchBoxTransp(false)
        setVisibleSearchBoxFornFiltro(false)
    }

    const handleChangeTabMEI = async (tab: number) => {
        const newTabs = await tabsMei.map((aba: Tab, index: number) => {
            itabsMei[index].active = itabsMei[index].index === tab
            return itabsMei[index]
        })
        setTabsMei(newTabs)
        setVisibleSearchBoxForn(false)
        setVisibleSearchBoxNatOp(false)
        setVisibleSearchBoxTransp(false)
        setVisibleSearchBoxFornFiltro(false)
    }

    useEffect(() => {

        if (tabs[0].active && tabsMei[0].active) {

            Inputfocus()

        } else if (tabs[2].active) {

            InputfocusImposto()

        } else if (tabs[3].active) {

            InputfocusFreteTransp()

        } else if (tabs[4].active || tabsMei[2].active) {

            InputfocusDupPagar()

        } else if (tabs[5].active || tabsMei[3].active) {

            InputfocusFiltro()
        }

    }, [tabs, tabsMei])

    const resetPageIndex = () => {

        setTabs(prevTabs =>
            prevTabs.map((tab, index) => ({
                ...tab,
                active: index === 0,
            }))
        )

        setTabsMei(prevTabs =>
            prevTabs.map((tab, index) => ({
                ...tab,
                active: index === 0,
            }))
        )

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 150)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    // -------------------------------------------------------------------------
    // FUNÇÕES DE FILTRO -------------------------------------------------------
    // -------------------------------------------------------------------------
    /*
    const filtrarItens = async (page: number = 0) => {

        let inicio = 0

        if (page > 0) {
            inicio = (page * parseInt(exibirItens)) - parseInt(exibirItens)
        }

        const newProdutosList = await produtos.filter((item, index) => {
            if (inicio === 0) {
                if (index + 1 <= parseInt(exibirItens)) {
                    return item
                }
            } else {
                if (index >= inicio && index <= (inicio + parseInt(exibirItens)) - 1) {
                    return item
                }
            }
        })

        setProdutosListCopy(newProdutosList)
    }

    const filtrarNotaFiscal = async (page: number = 0) => {

        let inicio = 0

        if (page > 0) {
            inicio = (page * parseInt(exibirItens)) - parseInt(exibirItens)
        }

        const newNFList = await NFList.filter((item, index) => {
            if (inicio === 0) {
                if (index + 1 <= parseInt(exibirItens)) {
                    return item
                }
            } else {
                if (index >= inicio && index <= (inicio + parseInt(exibirItens)) - 1) {
                    return item
                }
            }
        })

        //setNFListCopy(newNFList)
    }
    */

    // -------------------------------------------------------------------------
    // FUNÇÃO DE CÁLCULO DE PAGINA -----------------------------------------------
    // -------------------------------------------------------------------------
    /*
    const calcQtdPages = (qtdItens: number, itensPorPage: number) => {

        let qtd = 1 // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / parseInt(exibirItens))

        //console.log("qtd: ", qtd)
        //console.log("qtdItens: ", qtdItens)

        const newPages = []
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1)
        }

        setPagesItens(newPages)
    }

    const calcQtdPagesNF = (qtdItens: number, itensPorPage: number) => {

        let qtd = 1 // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / parseInt(exibirItens))

        const newPages = []
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1)
        }

        setPagesNF(newPages)
    }
    */

    // -------------------------------------------------------------------------
    // EVENTOS HANDLERS ----------------------------------------------------------
    // -------------------------------------------------------------------------
    /*
    const handleFilterItensPage = (page: number) => {
        setCurrentPage(page)
        filtrarItens(page)
        filtrarNotaFiscal(page)
    }

    // Calcule as páginas para mostrar, sempre 5 com a página atual no meio
    const getPageNumbers = () => {
        const maxVisiblePages = 5
        let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
        let end = Math.min(pagesNF.length, start + maxVisiblePages - 1)

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1)
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index)
    }

    const getPageNumbersItens = () => {
        const maxVisiblePages = 5
        let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
        let end = Math.min(pagesItens.length, start + maxVisiblePages - 1)

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1)
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index)
    }
    */


    // -------------------------------------------------------------------------
    // FUNCOES EXCLUIR --------------------------------------------------------
    // -------------------------------------------------------------------------
    const handleExcluirItem = useCallback(async (item: any) => {


        setModalShow(true)
        setVisible(false)
        setIdNItemExcluir(item.nitem)
        setNomeExcluir(item.desc_prod)

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }
    }, [])

    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingExcluir(true)

        try {

            const retAPI = await NotaEntradaService.Delete(idNF, idNItemExcluir, motivo, senha)

            if (!retAPI.error) {

                setProdutos(retAPI.data)
                setProdutosListCopy(retAPI.data)
                //calcQtdPages(retAPI.data.length, parseInt(exibirItens))

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Item excluído com sucesso`)

                const timer = setTimeout(() => {
                    setModalShow(false)
                    clearTimeout(timer)
                }, 1000)

            } else {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível excluir o item da nota fiscal`)

        } finally {
            setLoadingExcluir(false)
        }

    }, [idNF, idNItemExcluir])

    const fecharModalExclusao = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setModalShow(false)
        }

        setVisible(false)
    }, [messageType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setVisible(false)
        setModalShow(false)
    }, [])

    // -------------------------------------------------------------------------
    // FUNCOES DA API ITENS DA NF ----------------------------------------------
    // -------------------------------------------------------------------------
    /*
     useEffect(() => {
        //filtrarItens(currentPage)
        //setCurrentPage(1)
    }, [produtos, currentPage])
    */

    const handleNovoProdutoClick = () => {
        setVisibleModalItens(true)
    }

    const fecharModalLancarItem = useCallback(() => {
        setVisibleModalItens(false)
        setNitemNF(0)
    }, [])

    const handleEditarItem = useCallback(async (nitem: number) => {
        setVisibleModalItens(true)
        setNitemNF(nitem)
    }, [])

    const handleConfirmCadItem = useCallback((item: NFEntraItem, nitem: number) => {
        setVisibleModalItens(false)
        setNitemNF(0)

        const newProdutosList = produtos.some(produto => produto.nitem === nitem)
            ? // Atualiza a linha se o item já existir
            produtos.map(produto =>
                produto.nitem === nitem ? { ...produto, ...item } : produto
            )
            : // Adiciona uma nova linha se o item não existir
            [...produtos, item]

        setProdutosListCopy(newProdutosList)
        setProdutos(newProdutosList)

        //calcQtdPages(newProdutosList.length, parseInt(exibirItens))

        setVisible(true)
        setMessageType("SUCCESS")
        setMessage(`Produto lançado com sucesso`)

    }, [produtos])

    // -------------------------------------------------------------------------
    // FUNCOES DE FOCUS E LIMPAR DADOS -----------------------------------------
    // -------------------------------------------------------------------------
    const Inputfocus = () => {
        const inputElement = document.getElementById("num_doc")
        inputElement?.focus()
    }

    const InputfocusImposto = () => {
        const inputElement = document.getElementById("vl_desc")
        inputElement?.focus()
    }

    const InputfocusFreteTransp = () => {
        const inputElement = document.getElementById("modalidadeFrete")
        inputElement?.focus()
    }

    const InputfocusFiltro = () => {
        const inputElement = document.getElementById("dt_inicial__NF")
        inputElement?.focus()
    }

    const InputfocusDupPagar = () => {
        const inputElement = document.getElementById("num_docDupPagar")
        inputElement?.focus()
    }

    const InputDesfocusFiltro = () => {
        const inputElement = document.getElementById("dt_inicial__NF")
        inputElement?.blur()
    }

    const clearFields = () => {

        setVisible(false)
        setLoading(true)

        setNFList([])
        //setNFListCopy([])
        setProdutos([])
        setProdutosListCopy([])
        setNumNF("")
        setDtEmissao("")
        setDtChegada("")
        setIdFornecedor(0)
        setIdNatOp(0)
        setPagamento("0")
        setModelo("")
        setSerie("")
        setFinNFe("")
        setVlProdutos("0,00")
        setVlNF("0,00")

        setVlDesc("0,00")
        setVlFrete("0,00")
        setVlSeguro("0,00")
        setVlOutros("0,00")
        setVlIpi("0,00")
        setVlBcIcms("0,00")
        setVlIcms("0,00")
        setVlBcSt("0,00")
        setVlSt("0,00")
        setVlPis("0,00")
        setVlCofins("0,00")

        setModFrete("9")
        setIdTransp(0)
        setIdNF(0)

        //setExibirItens("8")

        setNFConfirmada(false)
        resetPageIndex()

        const timer = setTimeout(() => {
            Inputfocus()
            setLoading(false)
            clearTimeout(timer)
        }, 700)
    }

    const clearFieldsConfirmaNota = () => {

        setProdutos([])
        setProdutosListCopy([])
        setNumNF("")
        setDtEmissao("")
        setDtChegada("")
        setIdFornecedor(0)
        setIdNatOp(0)
        setPagamento("0")
        setModelo("")
        setSerie("")
        setFinNFe("")
        setVlProdutos("0,00")
        setVlNF("0,00")

        setVlDesc("0,00")
        setVlFrete("0,00")
        setVlSeguro("0,00")
        setVlOutros("0,00")
        setVlIpi("0,00")
        setVlBcIcms("0,00")
        setVlIcms("0,00")
        setVlBcSt("0,00")
        setVlSt("0,00")
        setVlPis("0,00")
        setVlCofins("0,00")

        setModFrete("9")
        setIdTransp(0)
        setIdNF(0)

        setParcelamentoList([])
        setIdDupPagar(0)
        setNumDocDupPagar("")
        setSerieDupPagar("")
        setValorDupPagar("0")
        setIdFornecedorDupPagar(0)
        setIdGrupoDespDupPagar(0)
        setDtVencimentoDupPagar("")
        setObservacaoDupPagar("")
        
        InputfocusDupPagar()
        setNFConfirmada(false)
    }

    const novoDupPagar = () => {
        setIdDupPagar(0)
        setNumDocDupPagar("")
        setSerieDupPagar("")
        setValorDupPagar("0")
        //setIdFornecedorDupPagar(0)
        setIdGrupoDespDupPagar(0)
        setDtVencimentoDupPagar("")
        setObservacaoDupPagar("")
        
        InputfocusDupPagar()

        if (messageType === "DANGER") {
            setVisible(false)
        }

    }

    // ------------------------------------------------------------------------------------
    // FUNCOES DE SALVAR E EXCLUIR DUP --------------------------------------------------------------
    // ------------------------------------------------------------------------------------
    const handleSalvarDupPagar = async () => {

        /*
        obs: as requisições que eu usei na api foram 'ConfirmarNF', 'ValidateConfirmNF' 
        */

        setLoadingDupPagar(true)
        setVisible(false)

        const showError = (message: string) => {
            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(message)
                clearTimeout(timer)
            }, 150)
        }

        try {

            if(idNF === 0 ){
                return showError("É preciso lançar uma nota fiscal antes");
            }

            if (parseFloat(valorDupPagar) === 0) {
                return showError("Valor da duplicata não pode ser zero");
            }
            
            if (idFornecedor === 0) {
                 return showError("Fornecedor não informado");
             }

            if (!dtVencimentoDupPagar) {
                return showError("Vencimento da duplicata não informado");
            }
            
            const novoItem: ParcelamentoDupPagar = {
                id: parcelamentoList.length + 1,
                num_doc: numDocDupPagar,
                serie: serieDupPagar,
                valor: parseFloat(valorDupPagar),
                id_fornecedor: idFornecedor,
                id_grupo_despesa: idGrupoDespDupPagar,
                id_subgrupo_despesa: idSubGrupoDespDupPagar,
                dtEmissao: dateI,
                dt_vencimento: dtVencimentoDupPagar,
                observacao: observacaoDupPagar,
                nomeFornecedor: nomeFornecedorDupPagar,
            }

            

            const retorno: RetAPI = await NotaEntradaService.SalvarDupPagar(idNF, novoItem)

            if (retorno.error){
                showError(retorno.msg || "")
                return
            }

            setParcelamentoList(prev => [...prev, novoItem]);
            novoDupPagar()

        } catch (error) {
            showError("Houve um erro ao adicionar a duplicata");
        } finally {
            setLoadingDupPagar(false);
        }
    }

    const handleDeleteParcel = async (parcel: ParcelamentoDupPagar) => {

        const retorno: RetAPI = await NotaEntradaService.ExcluirDupPagar(parcel.id)

        if (retorno.error){
            setVisible(true)
            setMessageType("DANGER")
            setMessage(retorno.msg || "")
            return
        }

        const newParcelasList = parcelamentoList.filter((item) => item.id !== parcel.id)
        setParcelamentoList(newParcelasList)
    }

    // -------------------------------------------------------------------------
    // FUNCOES DA API NF -------------------------------------------------------
    // -------------------------------------------------------------------------
    const handleSalvarNFClick = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)
        searchBoxFocus()

        try {

            const Nf: NFEntrada = {
                id: idNF,
                idFornecedor: idFornecedor,
                numNF: parseInt(numNF),
                idNatOp: idNatOp || 0,
                vlProdutos: parseFloat(vlProdutos.replaceAll(".", "").replaceAll(",", ".")),
                vlNF: parseFloat(vlNF.replaceAll(".", "").replaceAll(",", ".")),
                dtEmissao: dtEmissao,
                dtChegada: dtChegada,
                pagamento: pagamento || '0',
                modelo: modelo,
                serie: serie,
                finalidade: finNFe || '1',
                
                vl_desconto: parseFloat(vlDesc.replaceAll(".", "").replaceAll(",", ".")),
                vl_frete: parseFloat(vlFrete.replaceAll(".", "").replaceAll(",", ".")),
                vl_seguro: parseFloat(vlSeguro.replaceAll(".", "").replaceAll(",", ".")),
                vl_outras: parseFloat(vlOutros.replaceAll(".", "").replaceAll(",", ".")),
                vl_ipi: parseFloat(vlIpi.replaceAll(".", "").replaceAll(",", ".")),
                vl_bc_icms: parseFloat(vlBcIcms.replaceAll(".", "").replaceAll(",", ".")),
                v_icms: parseFloat(vlIcms.replaceAll(".", "").replaceAll(",", ".")),
                vl_bc_st: parseFloat(vlBcSt.replaceAll(".", "").replaceAll(",", ".")),
                vl_st: parseFloat(vlSt.replaceAll(".", "").replaceAll(",", ".")),
                vl_pis: parseFloat(vlPis.replaceAll(".", "").replaceAll(",", ".")),
                vl_cofins: parseFloat(vlCofins.replaceAll(".", "").replaceAll(",", ".")),

                mod_frete: parseInt(modFrete),
                id_transp: idTransp
            }

            const retAPI = await NotaEntradaService.Save(Nf)

            const nomeForn = attributesNFEntrada?.fornecedores?.find(
                item => item.id === idFornecedor
            )?.description || '';
            setNomeFornecedorDupPagar(nomeForn)
            setIdFornecedorDupPagar(idFornecedor)
            
            if (tabs[0].active && tabsMei[0].active) {

                Inputfocus()

            } else if (tabs[2].active) {

                InputfocusImposto()

            } else if (tabs[3].active) {
                InputfocusFreteTransp()
            }

            if (retAPI.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)

            } else {

                setVisible(true)
                setIdNF(retAPI.id || 0)
                setMessageType("SUCCESS")
                setMessage(idNF > 0 ? `Nota Fiscal atualizada com sucesso` : `Nota Fiscal salva com sucesso`)

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(idNF > 0 ? `Não foi possível atualizar a nota fiscal` : `Não foi possível salvar a nota fiscal`)

        } finally {
            setLoading(false)
        }
    }

    const confirmarNota = useCallback(async (id: number) => {

        setVisible(false)
        setLoading(true)

        try {

            const Nf: NFEntrada = {
                id: idNF,
                idFornecedor: idFornecedor,
                numNF: parseInt(numNF),
                idNatOp: idNatOp || 0,
                vlProdutos: parseFloat(vlProdutos.replaceAll(".", "").replaceAll(",", ".")),
                vlNF: parseFloat(vlNF.replaceAll(".", "").replaceAll(",", ".")),
                dtEmissao: dtEmissao,
                dtChegada: dtChegada,
                pagamento: pagamento,
                modelo: modelo,
                serie: serie,
                finalidade: finNFe,

                vl_desconto: parseFloat(vlDesc.replaceAll(".", "").replaceAll(",", ".")),
                vl_frete: parseFloat(vlFrete.replaceAll(".", "").replaceAll(",", ".")),
                vl_seguro: parseFloat(vlSeguro.replaceAll(".", "").replaceAll(",", ".")),
                vl_outras: parseFloat(vlOutros.replaceAll(".", "").replaceAll(",", ".")),
                vl_ipi: parseFloat(vlIpi.replaceAll(".", "").replaceAll(",", ".")),
                vl_bc_icms: parseFloat(vlBcIcms.replaceAll(".", "").replaceAll(",", ".")),
                v_icms: parseFloat(vlIcms.replaceAll(".", "").replaceAll(",", ".")),
                vl_bc_st: parseFloat(vlBcSt.replaceAll(".", "").replaceAll(",", ".")),
                vl_st: parseFloat(vlSt.replaceAll(".", "").replaceAll(",", ".")),
                vl_pis: parseFloat(vlPis.replaceAll(".", "").replaceAll(",", ".")),
                vl_cofins: parseFloat(vlCofins.replaceAll(".", "").replaceAll(",", ".")),

                mod_frete: parseInt(modFrete),
                id_transp: idTransp
            }

            const retAPISave = await NotaEntradaService.Save(Nf)

            const retAPI = await NotaEntradaService.ConfirmarNf(id, parcelamentoList)

            if (retAPI.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)
                return false
            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(retAPI.msg || ``)

                clearFieldsConfirmaNota()

                return true

                //setNFConfirmada(true)
                //await filterNF()
            }


        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível confirmar a nota fiscal`)
            return false

        } finally {
            setLoading(false)
        }
    }, [parcelamentoList])


    // -------------------------------------------------------------------------
    // FUNCOES DA API FILTROS DA NF --------------------------------------------
    // -------------------------------------------------------------------------
    /*
    useEffect(() => {
        //filtrarNotaFiscal(1)
        //setCurrentPage(1)
    }, [NFList])
    */

    const filterNF = async () => {

        setVisible(false)
        setLoading(true)
        InputDesfocusFiltro()

        try {

            let relDados: Relatorio = {
                datai: datai,
                dataf: dataf,
                idFornecedorFilter: idFornecedorFilter,
                status: status
            }

            setRelatorio(relDados)

            const retAPI = await NotaEntradaService.FiltrarNf(datai, dataf, idFornecedorFilter, status)
            
            /*
            if (status === 'N') {
                setStatusBtFilter(true)
            } else {
                setStatusBtFilter(false)
            }
            */

            if (retAPI) {
                setNFList(retAPI.data)
                //setNFListCopy(retAPI)
                //calcQtdPagesNF(retAPI.length, parseInt(exibirItens))
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as notas fiscais`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                InputfocusFiltro()
                clearTimeout(timer)
            }, 0)
        }
    }

    const habilitarNF = useCallback(async (id: number) => {

        setVisible(false)
        setLoading(true)

        try {

            const retAPI = await NotaEntradaService.HabilitarEditNf(id)

            if (retAPI.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || ``)
                return false
            } else {
                buscarDadosNF(id)
                return true
            }

        } catch (error) {
            setLoading(false)
            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível habilitar a nota fiscal`)
            return false
        }
        //setNFList([])
        //setNFListCopy([])
    }, [])

    const visualizarNF = useCallback(async (id: number) => {

        setVisible(false)
        setLoading(true)

        try {

            const resp = await NotaEntradaService.BuscarNF(id)
            setNFConfirmada(true)

            if (!resp.error) {

                setProdutos(resp.data.itensNF.length > 0 ? resp.data.itensNF : [])
                setProdutosListCopy(resp.data.itensNF.length > 0 ? resp.data.itensNF : [])

                setIdNF(resp.data.id || 0)
                setNumNF(resp.data.num_nf?.toString() || '')
                setDtEmissao(resp.data.dt_emissao || '')
                setDtChegada(resp.data.dt_chegada || '')
                setIdFornecedor(resp.data.id_fornecedor || 0)
                setIdNatOp(resp.data.id_nat_op || 0)
                setPagamento(resp.data.indPag?.toString() || '0')
                setModelo(resp.data.modelo?.toString() || '')
                setSerie(resp.data.serie?.toString() || '')
                setFinNFe(resp.data.fin_nfe?.toString() || '1')
                setVlProdutos(resp.data.vl_produtos ? Funcoes.numberFormat(resp.data.vl_produtos?.toString(), 'decimal', 2, 2) : '0,00')
                setVlNF(resp.data.vl_nf ? Funcoes.numberFormat(resp.data.vl_nf?.toString(), 'decimal', 2, 2) : '0,00')

                setVlDesc(resp.data.vl_desconto ? Funcoes.numberFormat(resp.data.vl_desconto?.toString(), 'decimal', 2, 2) : '0,00')
                setVlFrete(resp.data.vl_frete ? Funcoes.numberFormat(resp.data.vl_frete?.toString(), 'decimal', 2, 2) : '0,00')
                setVlSeguro(resp.data.vl_seguro ? Funcoes.numberFormat(resp.data.vl_seguro?.toString(), 'decimal', 2, 2) : '0,00')
                setVlOutros(resp.data.vl_outras ? Funcoes.numberFormat(resp.data.vl_outras?.toString(), 'decimal', 2, 2) : '0,00')
                setVlIpi(resp.data.vl_ipi ? Funcoes.numberFormat(resp.data.vl_ipi?.toString(), 'decimal', 2, 2) : '0,00')
                setVlBcIcms(resp.data.vl_bc_icms ? Funcoes.numberFormat(resp.data.vl_bc_icms?.toString(), 'decimal', 2, 2) : '0,00')
                setVlIcms(resp.data.v_icms ? Funcoes.numberFormat(resp.data.v_icms?.toString(), 'decimal', 2, 2) : '0,00')
                setVlBcSt(resp.data.vl_bc_st ? Funcoes.numberFormat(resp.data.vl_bc_st?.toString(), 'decimal', 2, 2) : '0,00')
                setVlSt(resp.data.vl_st ? Funcoes.numberFormat(resp.data.vl_st?.toString(), 'decimal', 2, 2) : '0,00')
                setVlPis(resp.data.vl_pis ? Funcoes.numberFormat(resp.data.vl_pis?.toString(), 'decimal', 2, 2) : '0,00')
                setVlCofins(resp.data.vl_cofins ? Funcoes.numberFormat(resp.data.vl_cofins?.toString(), 'decimal', 2, 2) : '0,00')

                setModFrete(resp.data.mod_frete?.toString() || '9')
                setIdTransp(resp.data.id_transp || 0)

                resetPageIndex()
                return true
            } else {
                return false
            }

            //await filterNF()

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível visualizar a nota fiscal`)
            return false

        } finally {
            setLoading(false)
        }

        //setNFList([])
        //setNFListCopy([])
    }, [])

    /*const excluirDadosNF = useCallback( 
        async (id:number) => {
           setVisible(false)
           setLoading(true)

            const resp = await NotaEntradaService.ExcluirNF(id)

            if (resp.error){
               setVisible(true)
               setMessageType("DANGER")
               setMessage(resp.msg || "")
               return false
            }

            return true;

        }    
    ,[])*/

    const buscarDadosNF = useCallback(async (id: number) => {

        setVisible(false)
        setLoading(true)

        try {

            const resp = await NotaEntradaService.BuscarNF(id)
            setNFConfirmada(false)

            if (!resp.error) {

                setProdutos(resp.data.itensNF.length > 0 ? resp.data.itensNF : [])
                setProdutosListCopy(resp.data.itensNF.length > 0 ? resp.data.itensNF : [])
                //calcQtdPages(resp.itensNF.length, parseInt(exibirItens))
                
                setParcelamentoList(resp.data.dupPagarList)

                setIdNF(resp.data.id || 0)
                setNumNF(resp.data.num_nf?.toString() || '')
                setDtEmissao(resp.data.dt_emissao || '')
                setDtChegada(resp.data.dt_chegada || '')
                setIdFornecedor(resp.data.id_fornecedor || 0)
                setIdNatOp(resp.data.id_nat_op || 0)
                setPagamento(resp.data.indPag?.toString() || '0')
                setModelo(resp.data.modelo?.toString() || '')
                setSerie(resp.data.serie?.toString() || '')
                setFinNFe(resp.data.fin_nfe?.toString() || '1')
                setVlProdutos(resp.data.vl_produtos ? Funcoes.numberFormat(resp.data.vl_produtos?.toString(), 'decimal', 2, 2) : '0,00')
                setVlNF(resp.data.vl_nf ? Funcoes.numberFormat(resp.data.vl_nf?.toString(), 'decimal', 2, 2) : '0,00')

                setVlDesc(resp.data.vl_desconto ? Funcoes.numberFormat(resp.data.vl_desconto?.toString(), 'decimal', 2, 2) : '0,00')
                setVlFrete(resp.data.vl_frete ? Funcoes.numberFormat(resp.data.vl_frete?.toString(), 'decimal', 2, 2) : '0,00')
                setVlSeguro(resp.data.vl_seguro ? Funcoes.numberFormat(resp.data.vl_seguro?.toString(), 'decimal', 2, 2) : '0,00')
                setVlOutros(resp.data.vl_outras ? Funcoes.numberFormat(resp.data.vl_outras?.toString(), 'decimal', 2, 2) : '0,00')
                setVlIpi(resp.data.vl_ipi ? Funcoes.numberFormat(resp.data.vl_ipi?.toString(), 'decimal', 2, 2) : '0,00')
                setVlBcIcms(resp.data.vl_bc_icms ? Funcoes.numberFormat(resp.data.vl_bc_icms?.toString(), 'decimal', 2, 2) : '0,00')
                setVlIcms(resp.data.v_icms ? Funcoes.numberFormat(resp.data.v_icms?.toString(), 'decimal', 2, 2) : '0,00')
                setVlBcSt(resp.data.vl_bc_st ? Funcoes.numberFormat(resp.data.vl_bc_st?.toString(), 'decimal', 2, 2) : '0,00')
                setVlSt(resp.data.vl_st ? Funcoes.numberFormat(resp.data.vl_st?.toString(), 'decimal', 2, 2) : '0,00')
                setVlPis(resp.data.vl_pis ? Funcoes.numberFormat(resp.data.vl_pis?.toString(), 'decimal', 2, 2) : '0,00')
                setVlCofins(resp.data.vl_cofins ? Funcoes.numberFormat(resp.data.vl_cofins?.toString(), 'decimal', 2, 2) : '0,00')

                setModFrete(resp.data.mod_frete?.toString() || '9')
                setIdTransp(resp.data.id_transp || 0)

                resetPageIndex()
                return true
            } else {
                return false
            }

            //await filterNF()

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os dados da nota fiscal`)
            return false
        } finally {
            setLoading(false)
        }

        //setNFList([])
        //setNFListCopy([])

    }, [])

    // ---------------------------------------------------------------- FOCUS ABA 1 -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        numNotaF: useRef(null),
        dataEmissao: useRef(null),
        dataChegada: useRef(null),
        fornecedor: useRef(null),
        natOpe: useRef(null),
        pagamento: useRef(null),
        modelo: useRef(null),
        serie: useRef(null),
        finalidade: useRef(null),
        valorProd: useRef(null),
        valorNF: useRef(null),
    }

    const handle_Tab_Press_Principal = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active && !nfConfirmada) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 3) {
                setVisibleSearchBoxForn(true)
                inputFocusFornecedor()
            }

            if (nextIndex === 4) {
                setVisibleSearchBoxNatOp(true)
                inputFocusNatOp()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active && !nfConfirmada) {

                event.preventDefault()

                const inputSearchForn = document.getElementById('inputSearchBox-forn') as HTMLInputElement
                const inputSearchNatOp = document.getElementById('inputSearchBox-natOp') as HTMLInputElement

                if (document.activeElement === inputSearchForn) {

                    clickSearchBoxNatOp()
                    setVisibleSearchBoxForn(false)

                } else if (document.activeElement === inputSearchNatOp) {
                    inputsRefs['pagamento'].current?.focus()
                    setVisibleSearchBoxNatOp(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [nfConfirmada, tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxForn(false)
        setVisibleSearchBoxNatOp(false)
    }

    // FORNECEDOR ------------------------------------------------------------
    const boxFocusForn = () => {
        // Move o foco para o input correspondente à chave 'fornecedor'.
        inputsRefs['fornecedor'].current?.focus()
    }

    const clickSearchBoxForn = useCallback(() => {
        setVisibleSearchBoxForn((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxNatOp e foca no SearchBoxForn
                setVisibleSearchBoxNatOp(false)
                inputFocusFornecedor()
            }
            return newState
        })
        boxFocusForn()
    }, [])

    const inputFocusFornecedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-forn`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // NATUREZA DA OPERAÇÃO
    const boxFocusNatOp = () => {
        // Move o foco para o input correspondente à chave 'natOpe'.
        inputsRefs['natOpe'].current?.focus()
    }

    const clickSearchBoxNatOp = useCallback(() => {
        setVisibleSearchBoxNatOp((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxForn e foca no SearchBoxNatOp
                setVisibleSearchBoxForn(false)
                inputFocusNatOp()
            }
            return newState
        })
        boxFocusNatOp()
    }, [])

    const inputFocusNatOp = () => {
        let inputSearch = document.getElementById(`inputSearchBox-natOp`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ---------------------------------------------------------------- FOCUS ABA 3 -----------------------------------------------------------------
    const inputsRefsImposto: InputsRefs = {
        desconto: useRef(null),
        frete: useRef(null),
        seguro: useRef(null),
        outros: useRef(null),
        ipi: useRef(null),
        baseCalcICMS: useRef(null),
        valorICMS: useRef(null),
        baseCalcICMSst: useRef(null),
        valorICMSst: useRef(null),
        valorPis: useRef(null),
        valorConfins: useRef(null),
    }

    const handle_Tab_Press_Imposto = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[2].active && !nfConfirmada) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsImposto)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefsImposto[keys[nextIndex]].current?.disabled || inputsRefsImposto[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefsImposto[keys[nextIndex]].current?.focus()
        }
    }

    // ---------------------------------------------------------------- FOCUS ABA 4 -----------------------------------------------------------------
    const inputsRefsFrete: InputsRefs = {
        modalidadeFrete: useRef(null),
        transportadora: useRef(null),
    }

    const handle_Tab_Press_Frete = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[3].active && !nfConfirmada) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            setVisibleSearchBoxTransp(false)

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsFrete)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefsFrete[keys[nextIndex]].current?.disabled || inputsRefsFrete[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 1) {
                setVisibleSearchBoxTransp(true)
                inputFocusTransp()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefsFrete[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[3].active && !nfConfirmada) {

                event.preventDefault()

                const inputSearchTransp = document.getElementById('inputSearchBox-transp') as HTMLInputElement

                if (document.activeElement === inputSearchTransp) {
                    inputsRefsFrete['modalidadeFrete'].current?.focus()
                    setVisibleSearchBoxTransp(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [nfConfirmada, tabs])

    const searchBoxFocusFrete = () => {
        setVisibleSearchBoxTransp(false)
    }

    const boxFocusTransp = () => {
        // Move o foco para o input correspondente à chave 'transportadora'.
        inputsRefsFrete['transportadora'].current?.focus()
    }

    const clickSearchBoxTransp = useCallback(() => {
        setVisibleSearchBoxTransp((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Foca no SearchBoxTransp
                inputFocusTransp()
            }
            return newState
        })
        boxFocusTransp()
    }, [])

    const inputFocusTransp = () => {
        let inputSearch = document.getElementById(`inputSearchBox-transp`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ---------------------------------------------------------------- FOCUS ABA 6 -----------------------------------------------------------------
    const inputsRefsDupPagar: InputsRefs = {
        numDuplicataDupPagar: useRef(null),
        serieDupPagar: useRef(null),
        valorDupPagar: useRef(null),
        fornecedorDupPagar: useRef(null),
        grupoDespesaDupPagar: useRef(null),
        subgrupoDespesaDupPagar: useRef(null),
        dataEmissaoDupPagar: useRef(null),
        dataVencimentoDupPagar: useRef(null),
        observacaoDupPagar: useRef(null),
    }

    const handleTabPressDupPagar = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && (tabs[4].active || tabsMei[2].active)) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocusDupPagar()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsDupPagar)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefsDupPagar[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 3) {
                setVisibleSearchBoxFornecedorDupPagar(true)
                inputFocusFornecedorDupPagar()
            }

            if (nextIndex === 4) {
                setVisibleSearchBoxGrupoDespesaDupPagar(true)
                inputFocusGrupoDespDupPagar()
            }

            if (nextIndex === 5 && idGrupoDespDupPagar > 0) {
                console.log("aki1")
                setVisibleSearchBoxSubGrupoDespesaDupPagar(true)
                inputFocusSubGrupoDespDupPagar()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefsDupPagar[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && (tabs[4].active || tabsMei[2].active)) {

                event.preventDefault()

                const inputSearchForn = document.getElementById('inputSearchBox-fornecedorDupPagar') as HTMLInputElement
                const inputSearchGrupoDesp = document.getElementById('inputSearchBox-grupoDespesaDupPagar') as HTMLInputElement
                const inputSearchSubGrupoDesp = document.getElementById('inputSearchBox-subgrupoDespesaDupPagar') as HTMLInputElement

                if (document.activeElement === inputSearchForn) {

                    clickSearchBoxGrupoDespesaDupPagar()
                    setVisibleSearchBoxFornecedorDupPagar(false)

                } else if (document.activeElement === inputSearchGrupoDesp && idGrupoDespDupPagar === 0) {
                    inputsRefsDupPagar['dataVencimentoDupPagar'].current?.focus()
                    setVisibleSearchBoxGrupoDespesaDupPagar(false)

                } else if (document.activeElement === inputSearchGrupoDesp) {
                    clickSearchBoxSubGrupoDespesaDupPagar()
                    setVisibleSearchBoxGrupoDespesaDupPagar(false)

                } else if (document.activeElement === inputSearchSubGrupoDesp) {
                    inputsRefsDupPagar['dataVencimentoDupPagar'].current?.focus()
                    setVisibleSearchBoxSubGrupoDespesaDupPagar(false)
                }

            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [tabs, tabsMei, idGrupoDespDupPagar])

    const handleInputFocusDupPagar = () => {
        setVisibleSearchBoxFornecedorDupPagar(false)
        setVisibleSearchBoxGrupoDespesaDupPagar(false)
        setVisibleSearchBoxSubGrupoDespesaDupPagar(false)
    }

    // FORNECEDOR -------------------------------------------------
    const boxFocusFornecedorDupPagar = () => {
        // Move o foco para o input correspondente à chave 'fornecedor'.
        inputsRefsDupPagar['fornecedorDupPagar'].current?.focus()
    }

    const clickSearchBoxFornecedorDupPagar = useCallback(() => {
       /*
        setVisibleSearchBoxFornecedorDupPagar((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxGrupoDespesa e foca no SearchBoxFornecedor
                setVisibleSearchBoxGrupoDespesaDupPagar(false);
                inputFocusFornecedorDupPagar();
            }
            return newState;
        });
        boxFocusFornecedorDupPagar(); // Mantém fora do estado para ser executado independentemente
        */
    }, [])

    const inputFocusFornecedorDupPagar = () => {
        let inputSearch = document.getElementById(`inputSearchBox-fornecedorDupPagar`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // GRUPO DESPESA -------------------------------------------------
    const boxFocusGrupoDespesaDupPagar = () => {
        // Move o foco para o input correspondente à chave 'grupoDespesa'.
        inputsRefsDupPagar['grupoDespesaDupPagar'].current?.focus()
    }

    const clickSearchBoxGrupoDespesaDupPagar = useCallback(() => {
        setVisibleSearchBoxGrupoDespesaDupPagar((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxFornecedor e foca no SearchBoxGrupoDesp
                setVisibleSearchBoxFornecedorDupPagar(false);
                inputFocusGrupoDespDupPagar();
            }
            return newState;
        });
        boxFocusGrupoDespesaDupPagar(); // Mantém fora do estado para ser executado independentemente
    }, [])

    const inputFocusGrupoDespDupPagar = () => {
        let inputSearch = document.getElementById(`inputSearchBox-grupoDespesaDupPagar`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SUBGRUPO DESPESA -------------------------------------------------
    const boxFocusSubGrupoDespesaDupPagar = () => {
        // Move o foco para o input correspondente à chave 'grupoDespesa'.
        inputsRefsDupPagar['subgrupoDespesaDupPagar'].current?.focus()
    }

    const clickSearchBoxSubGrupoDespesaDupPagar = useCallback(() => {
        setVisibleSearchBoxSubGrupoDespesaDupPagar((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxFornecedor e foca no SearchBoxGrupoDesp
                setVisibleSearchBoxFornecedorDupPagar(false);
                setVisibleSearchBoxGrupoDespesaDupPagar(false);
                inputFocusSubGrupoDespDupPagar();
            }
            return newState;
        });
        boxFocusSubGrupoDespesaDupPagar(); // Mantém fora do estado para ser executado independentemente
    }, [])

    const inputFocusSubGrupoDespDupPagar = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subgrupoDespesaDupPagar`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ---------------------------------------------------------------- FOCUS ABA 7 -----------------------------------------------------------------
    const inputsRefsFiltro: InputsRefs = {
        dtEmissao: useRef(null),
        dtChegada: useRef(null),
        notas: useRef(null),
        fornecedorFiltro: useRef(null),
    }

    const handle_Tab_Press_Filtro = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && (tabs[5].active || tabsMei[3].active)) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            setVisibleSearchBoxFornFiltro(false)

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsFiltro)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefsFiltro[keys[nextIndex]].current?.disabled || inputsRefsFiltro[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 3) {
                setVisibleSearchBoxFornFiltro(true)
                inputFocusFornFiltro()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefsFiltro[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && (tabs[5].active || tabsMei[3].active)) {

                event.preventDefault()

                const inputSearchFornFiltro = document.getElementById('inputSearchBox-fornFiltro') as HTMLInputElement

                if (document.activeElement === inputSearchFornFiltro) {
                    inputsRefsFiltro['dtEmissao'].current?.focus()
                    setVisibleSearchBoxFornFiltro(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs, tabsMei])

    const searchBoxFocusFiltro = () => {
        setVisibleSearchBoxFornFiltro(false)
    }

    const boxFocusFornFiltro = () => {
        // Move o foco para o input correspondente à chave 'fornecedorFiltro'.
        inputsRefsFiltro['fornecedorFiltro'].current?.focus()
    }

    const clickSearchBoxFornFiltro = useCallback(() => {
        setVisibleSearchBoxFornFiltro((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Foca no SearchBoxFornFiltro
                inputFocusFornFiltro()
            }
            return newState
        })
        boxFocusFornFiltro()
    }, [])

    const inputFocusFornFiltro = () => {
        let inputSearch = document.getElementById(`inputSearchBox-fornFiltro`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //----------------------------------------------------------------- FOCUS NONE --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {
            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs, tabsMei])


    // -------------------------------------------------------------------------
    // SEM USO -----------------------------------------------------------------
    // -------------------------------------------------------------------------
    const handleChangeExibirItens = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setExibirItens(e.target.value)
    }

    const handleChangeNatOp = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setNatOp(e.target.value)
    }

    const initializeProdutos = () => {
        /*
        let newProdutosList: Item[] = [
            { nitem: 1, descricao: "Arroz", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 2, descricao: "Feijão", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 3, descricao: "Macarrão", qtd: 1, unit: 100910.22, vTot: 100910.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 4, descricao: "Batata", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 5, descricao: "Tomate", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 6, descricao: "Cebola", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 7, descricao: "Carne", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 8, descricao: "Azeite", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 9, descricao: "Óleo de Cozinha", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 10, descricao: "Azeitona", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 11, descricao: "Pão de Sal", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 12, descricao: "Pão de Forma", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 13, descricao: "Tempero", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 14, descricao: "Alho", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 },
            { nitem: 15, descricao: "Cebola Roxa", qtd: 1, unit: 10.22, vTot: 10.22, pIcms: 12.00, cfop: 5102 }
        ]
        */

        //setProdutos(newProdutosList)
    }

    const handleClearFilterProdutosList = () => {
        //let newProdutosList = [...attributesNFEntrada?.produtos || []]
        //setProdutosList(newProdutosList)
    }

    const handleFilterProdutosList = (descricao: string) => {
        /*
        if (descricao.trim() === "") {
            let newProdutosList = [...attributesNFEntrada?.produtos || []]
            setProdutosList(newProdutosList)
        } else {
            let newProdutosList = [...attributesNFEntrada?.produtos || []]
            newProdutosList = newProdutosList.filter((item: Produto) => item.descricao.trim().toUpperCase().startsWith(descricao.trim().toLocaleUpperCase()))
            setProdutosList(newProdutosList)
        }
        */
    }

    const handleNewNFClick = () => {
        //resetPageIndex()
        //clearFields()
    }

    const handleChangeEndeTransp = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setEndeTransp(e.target.value)
    }

    const handleChangeCNPJTransp = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setCNPJTransp(e.target.value)
    }

    // ESTADO ----------------------------------------------------
    const handleClearUfSelecionada = () => {
        //const newUfList = [...attuf || []]
        //setUf(newUfList)
        //setIdUf(0)
    }

    const handleFilterUfClick = async (description: string) => {
        /*
        if (description === "") {
            const newUfList = [...attuf || []]
            //setUf(newUfList)
        } else {

            const newUfList = [...attuf || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            // setUf(newUfList || [])
        }
        */
    }

    const handleUfSelectClick = (v: Estado) => {
        //const newUfList = [...attuf || []]
        //setIdUf(v.id)
        //setUf(newUfList)
    }
    // ------------------------------------------------------------

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground} `}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`grid grid-cols-12 gap-4 p-2`}>

                            <div className={`relative col-span-12 lg:col-span-3 2xl:col-span-6 flex flex-row items-center`}>
                                <FaFileDownload className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>{'Entrada de NF'}</span>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 lg:col-span-3 2xl:col-span-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} ${classWeigthBt} sm:min-w-full sm:max-w-full h-9`} onClick={clearFields}>
                                    <IoAddCircleSharp size={"20px"} className={`mr-1 hidden md:block`} /> Nova NF
                                </button>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 lg:col-span-3 2xl:col-span-2`}>
                                <button tabIndex={-1} className={`${classBt} ${classbtVerde} h-9 disabled:cursor-not-allowed disabled:bg-opacity-70`} onClick={() => confirmarNota(idNF)} disabled={idNF == 0}>
                                    <FaCheck size={"20px"} className={`mr-1 hidden md:block`} /> Confirmar NF
                                </button>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 lg:col-span-3 2xl:col-span-2`}>
                                <button tabIndex={-1} className={`${classBt} ${classbtAzul} h-9 disabled:cursor-not-allowed disabled:bg-opacity-70`} disabled={nfConfirmada} onClick={handleSalvarNFClick}>
                                    <IoSave size={"18px"} className={`mr-1 hidden md:block`} />
                                    {idNF > 0 ? 'Atualizar Dados da NF' : 'Salvar Dados da NF'}
                                </button>
                            </div>

                        </div>

                        { /* Abas */}
                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {regTrib === 'MEI' ?
                                    tabsMei.map((item) => {
                                        return (
                                            <button tabIndex={-1} onClick={() => handleChangeTabMEI(item.index)} key={item.index.toString()}
                                                className={`px-4 font-mono font-bold min-w-[210px]
                                                    ${item.active ?
                                                        `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                        `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                    }`}>
                                                <div tabIndex={-1} className={`flex items-center`}>
                                                    <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                    <span className={`text-sm roboto`}>{item.titulo}</span>
                                                </div>
                                            </button>
                                        )
                                    })
                                    :

                                    tabs.map((item) => {
                                        return (
                                            <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                                className={`px-4 font-mono font-bold min-w-[210px]
                                                    ${item.active ?
                                                        `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                        `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                    }`}>
                                                <div tabIndex={-1} className={`flex items-center`}>
                                                    <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                    <span className={`text-sm roboto`}>{item.titulo}</span>
                                                </div>
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            { /* Abas */}

                            { /* Conteúdo */}
                            { /* Principal */}
                            <div className={`${regTrib === 'MEI' ? tabsMei[0]?.active === false ? 'hidden' : 'visible' : tabs[0]?.active === false ? 'hidden' : 'visible'} relative`}>

                                <div className={`w-full grid gap-4 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados da NF</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 `} size={18} />

                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='right' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>

                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${numNF !== '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.numNotaF} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'numNotaF')} id="num_doc" className={`${classInput} ${classInputDark} ${numNF !== '' ? '' : focusRed}`} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={numNF} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeNumNF} />
                                        <label htmlFor="num_doc" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}  ${numNF !== '' ? '' : focusLabelRed}`}>Número da Nota Fiscal</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${dtEmissao !== '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataEmissao} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'dataEmissao')} id="dt_emissao" className={`${classInput} ${classInputDark} ${dtEmissao === "" ? `text-blue-500 dark:text-cyan-300 ${focusRed}` : ``} dark:[color-scheme:dark]`} type="date" min="1900-01-01" max="9999-12-31" placeholder=" " autoComplete="off" value={dtEmissao} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeDtEmissao} />
                                        <label htmlFor="dt_emissao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dtEmissao !== '' ? '' : focusLabelRed}`}>Data de Emissão</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${dtChegada !== '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataChegada} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'dataChegada')} id="dt_chegada" className={`${classInput} ${classInputDark} ${dtChegada === "" ? `text-blue-500 dark:text-cyan-300 ${focusRed}` : ``} dark:[color-scheme:dark]`} type="date" min="1900-01-01" max="9999-12-31" placeholder=" " autoComplete="off" value={dtChegada} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeDtChegada} />
                                        <label htmlFor="dt_chegada" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dtChegada !== '' ? '' : focusLabelRed}`}>Data de Chegada</label>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-5 2xl:col-span-6 mt-1`}>

                                        <div ref={inputsRefs['fornecedor']} tabIndex={nfConfirmada ? -1 : 0} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'fornecedor')} />
                                        <div className={`${barraVermelhoAzul} ${idFornecedor !== 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={fornecedores}
                                            idRegistro={idFornecedor}
                                            label="Fornecedor"
                                            componentId='forn'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxForn}
                                            disabled={nfConfirmada}
                                            clearDataClick={handleClearFornSelecionado}
                                            setDataClick={handleClickSelectFornecedor}
                                            filterDataClick={handleFilterFornecedores}
                                            clicado={clickSearchBoxForn}/>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-5 2xl:col-span-4 mt-1`}>

                                        <div ref={inputsRefs['natOpe']} tabIndex={nfConfirmada ? -1 : 0} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'natOpe')} />
                                        <div className={`${barraVermelhoAzul} ${idNatOp !== 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={naturezas}
                                            idRegistro={idNatOp}
                                            label="Natureza da operação"
                                            componentId='natOp'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxNatOp}
                                            disabled={nfConfirmada}
                                            clearDataClick={handleClearNatOpSelecionado}
                                            setDataClick={handleClickSelectNatOp}
                                            filterDataClick={handleFilterNatOp}
                                            clicado={clickSearchBoxNatOp}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <select ref={inputsRefs.pagamento} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'pagamento')} id="pagamento" className={`${classInput} ${classInputDark}`} value={pagamento} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangePagamento}>
                                            <option value="0">Pagamento à vista</option>
                                            <option value="1">Pagamento à prazo</option>
                                            <option value="2">Outros</option>
                                        </select>
                                        <label htmlFor="pagamento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Pagamento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-1 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${modelo !== "" ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.modelo} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'modelo')} id="modelo" className={`${classInput} ${classInputDark} ${modelo !== "" ? '' : focusRed}`} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={modelo} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeModelo} />
                                        <label htmlFor="modelo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${modelo !== "" ? '' : focusLabelRed}`}>Modelo</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 2xl:col-span-1 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.serie} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'serie')} id="serie" className={`${classInput} ${classInputDark}`} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={serie} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeSerie} />
                                        <label htmlFor="serie" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Série</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <select ref={inputsRefs.finalidade} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'finalidade')} id="finalidadeNF" className={`${classInput} ${classInputDark}`} value={finNFe} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeFinNFe}>
                                            <option value="1">NF-e normal</option>
                                            <option value="2">NF-e complementar</option>
                                            <option value="3">NF-e de ajuste</option>
                                        </select>
                                        <label htmlFor="finalidadeNF" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Finalidade</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${vlProdutos !== "0,00" ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valorProd} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'valorProd')} id="vl_produtos" className={`${classInput} ${classInputDark} ${vlProdutos !== "0,00" ? '' : focusRed}`} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlProdutos} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleGhangeVlProdutos} />
                                        <label htmlFor="vl_produtos" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${vlProdutos !== "0,00" ? '' : focusLabelRed}`}>Valor dos Produtos</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                        <div className={`${barraVermelhoAzul} ${vlNF !== "0,00" ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valorNF} onKeyDown={(e) => handle_Tab_Press_Principal(e, 'valorNF')} id="vl_nf" className={`${classInput} ${classInputDark} ${vlNF !== "0,00" ? '' : focusRed}`} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlNF} disabled={nfConfirmada} onFocus={searchBoxFocus} onChange={handleChangeVlNF} />
                                        <label htmlFor="vl_nf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${vlNF !== "0,00" ? '' : focusLabelRed}`}>Valor da Nota Fiscal</label>
                                    </div>

                                    {/* 
                                        <div className="relative col-span-12 cursor-pointer md:col-span-4 lg:col-span-2 xl:col-span-1">
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} /> 
                                            <select className={`${classInput} ${classInputDark}`} value={exibirItens} onChange={handleChangeExibirItens}>
                                                <option value={2}>2 itens</option>
                                                <option value={4}>4 itens</option>
                                                <option value={5}>5 itens</option>
                                                <option value={7}>7 itens</option>
                                                <option value={10}>10 itens</option>
                                            </select>
                                            <label htmlFor="vl_nf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Exibir</label>
                                        </div>
                                        */}

                                </div>

                            </div>
                            { /* Principal */}

                            {/* Produtos da Nota Fiscal */}
                            <div className={`${regTrib === 'MEI' ? tabsMei[1]?.active === false ? 'hidden' : 'visible' : tabs[1]?.active === false ? 'hidden' : 'visible'} relative h-[900px] sm:h-[700px] xl:h-[630px]`}>

                                <div className="w-full h-10 mt-2 mb-3">
                                    <button tabIndex={-1} disabled={idNF === 0 || nfConfirmada} className={`${classBt} ${classbtVerde} disabled:cursor-not-allowed disabled:bg-opacity-70 max-w-[150px] mx-1`} onClick={handleNovoProdutoClick}>
                                        <IoAddCircleSharp size={"20px"} className="mr-1" /> Novo produto
                                    </button>
                                </div>

                                <GridEntradaNotaItem
                                    produtos={produtosListCopy}
                                    handleEditarItem={handleEditarItem}
                                    handleExcluirItem={handleExcluirItem}
                                    btHabilitado={nfConfirmada}
                                />

                            </div>
                            {/* Produtos da Nota Fiscal */}

                            { /* Imposto */}
                            <div className={`${tabs[2]?.active === false ? 'hidden' : 'visible'} `}>

                                <div className={`w-full grid gap-4 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.desconto} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'desconto')} id="vl_desc" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlDesc} disabled={nfConfirmada} onChange={handleGhangeVlDesconto} />
                                        <label htmlFor="vl_desc" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.frete} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'frete')} id="vl_frete" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlFrete} disabled={nfConfirmada} onChange={handleGhangeVlFrete} />
                                        <label htmlFor="vl_frete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Frete</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.seguro} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'seguro')} id="vl_seguro" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlSeguro} disabled={nfConfirmada} onChange={handleGhangeVlSeguro} />
                                        <label htmlFor="vl_seguro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Seguro</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.outros} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'outros')} id="vl_outras" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlOutros} disabled={nfConfirmada} onChange={handleGhangeVlOutros} />
                                        <label htmlFor="vl_outras" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Outras</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.ipi} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'ipi')} id="vl_ipi" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlIpi} disabled={nfConfirmada} onChange={handleGhangeVlIpi} />
                                        <label htmlFor="vl_ipi" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>IPI</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.baseCalcICMS} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'baseCalcICMS')} id="vl_bc_icms" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlBcIcms} disabled={nfConfirmada} onChange={handleGhangeVlBcIcms} />
                                        <label htmlFor="vl_bc_icms" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Base de Cálc. do ICMS</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.valorICMS} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'valorICMS')} id="vl_icms" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlIcms} disabled={nfConfirmada} onChange={handleGhangeVlIcms} />
                                        <label htmlFor="vl_icms" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do ICMS</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.baseCalcICMSst} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'baseCalcICMSst')} id="vl_bc_st" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlBcSt} disabled={nfConfirmada} onChange={handleGhangeVlBcSt} />
                                        <label htmlFor="vl_bc_st" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Base de Cálc. do ICMS-ST</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.valorICMSst} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'valorICMSst')} id="vl_st" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlSt} disabled={nfConfirmada} onChange={handleGhangeVlSt} />
                                        <label htmlFor="vl_st" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do ICMS-ST</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.valorPis} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'valorPis')} id="vl_pis" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlPis} disabled={nfConfirmada} onChange={handleGhangeVlPis} />
                                        <label htmlFor="vl_pis" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do PIS</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <input ref={inputsRefsImposto.valorConfins} onKeyDown={(e) => handle_Tab_Press_Imposto(e, 'valorConfins')} id="vl_cofins" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlCofins} disabled={nfConfirmada} onChange={handleGhangeVlCofins} />
                                        <label htmlFor="vl_cofins" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do COFINS</label>
                                    </div>

                                </div>

                            </div>
                            { /* Imposto */}

                            { /* Frete/Transportadora */}
                            <div className={`${tabs[3]?.active === false ? 'hidden' : 'visible'} `}>

                                <div className={`w-full grid gap-4 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 md:col-span-4 xl:col-span-3 2xl:col-span-2`}>
                                        <select ref={inputsRefsFrete.modalidadeFrete} onKeyDown={(e) => handle_Tab_Press_Frete(e, 'modalidadeFrete')} id="modalidadeFrete" className={`${classInput} ${classInputDark}`} value={modFrete} disabled={nfConfirmada} onFocus={searchBoxFocusFrete} onChange={handleChangeModFrete}>
                                            <option value="0">Por conta do emitente</option>
                                            <option value="1">Por conta do destinatário/remetente</option>
                                            <option value="2">Por conta de terceiros</option>
                                            <option value="9">Sem frete</option>
                                        </select>
                                        <label htmlFor="modalidadeFrete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Modalidade de Frete</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-8 xl:col-span-5`}>

                                        <div ref={inputsRefsFrete['transportadora']} tabIndex={nfConfirmada ? -1 : 0} onKeyDown={(e) => handle_Tab_Press_Frete(e, 'transportadora')} />
                                        <SearchBox
                                            dataList={transportadoras}
                                            idRegistro={idTransp}
                                            visibleTAB={visibleSearchBoxTransp}
                                            disabled={nfConfirmada}
                                            label="Transportadora"
                                            componentId='transp'
                                            clearDataClick={handleClearTranspSelecionada}
                                            setDataClick={handleClickSelectTransp}
                                            filterDataClick={handleFilterTransp}
                                            clicado={clickSearchBoxTransp}
                                        />
                                    </div>

                                </div>
                            </div>
                            { /* Frete/Transportadora */}

                            { /* Dup. Pagar */}
                            <div className={`${regTrib === 'MEI' ? tabsMei[2]?.active === false ? 'hidden' : 'visible' : tabs[4]?.active === false ? 'hidden' : 'visible'}`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Lançamento Manual</span>
                                            <FaRegQuestionCircle data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>

                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsDupPagar.numDuplicataDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'numDuplicataDupPagar')} id="num_docDupPagar" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} autoComplete="off" placeholder=' ' value={numDocDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeNumDocDupPagar} />
                                        <label htmlFor="num_docDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Num. Duplicata</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsDupPagar.serieDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'serieDupPagar')} id="serieDupPagar" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' autoComplete="off" placeholder=' ' value={serieDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeSerieDupPagar} />
                                        <label htmlFor="serieDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Série</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${parseFloat(valorDupPagar) > 0 ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefsDupPagar.valorDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'valorDupPagar')} id="valorDupPagar" 
                                        className={`${classInput} ${classInputDark} ${parseFloat(valorDupPagar) > 0 ? '' : focusRed}`} type='text' inputMode='numeric' 
                                        autoComplete="off" placeholder=' ' value={valorDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeValorDupPagar} />
                                        <label htmlFor="valorDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(valorDupPagar) > 0 ? '' : focusLabelRed}`}>Valor (R$)</label>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-6`}>
                                        <input id="fornecedorDupPagar" className={`${classInput} ${classInputDark}`} disabled={true} value={nomeFornecedorDupPagar} readOnly/>
                                        <label htmlFor="fornecedorDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Fornecedor</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                        <div ref={inputsRefsDupPagar['grupoDespesaDupPagar']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'grupoDespesaDupPagar')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={grupoDespListDupPagar}
                                            idRegistro={idGrupoDespDupPagar || undefined}
                                            label='Grupo de Despesa'
                                            componentId='grupoDespesaDupPagar'
                                            visibleTAB={visibleSearchBoxGrupoDespesaDupPagar}
                                            setDataClick={handleGrupoDespSelectClickDupPagar}
                                            clearDataClick={handleClearGrupoDespSelecionadaDupPagar}
                                            filterDataClick={handleFilterGrupoDespClickDupPagar}
                                            clicado={clickSearchBoxGrupoDespesaDupPagar}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                        <div ref={inputsRefsDupPagar['subgrupoDespesaDupPagar']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'subgrupoDespesaDupPagar')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={subGrupoDespListDupPagar}
                                            idRegistro={idSubGrupoDespDupPagar}
                                            disabled={idGrupoDespDupPagar === 0}
                                            label='SubGrupo de Despesa'
                                            componentId='subgrupoDespesaDupPagar'
                                            visibleTAB={visibleSearchBoxSubGrupoDespesaDupPagar}
                                            setDataClick={handleSubGrupoDespSelectClickDupPagar}
                                            clearDataClick={handleClearSubGrupoDespSelecionadaDupPagar}
                                            filterDataClick={handleFilterSubGrupoDespClickDupPagar}
                                            clicado={clickSearchBoxSubGrupoDespesaDupPagar}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsDupPagar.dataEmissaoDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'dataEmissaoDupPagar')} id="dt_emissaoDupPagar" className={`${classInput} ${classInputDark} dark:[color-scheme:dark] cursor-not-allowed`} type='date' min="1900-01-01" max="9999-12-31" autoComplete="off" placeholder=" " disabled={true} value={dtEmissaoDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeDtEmissaoDupPagar} />
                                        <label htmlFor="dt_emissaoDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Emissão</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${dtVencimentoDupPagar != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefsDupPagar.dataVencimentoDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'dataVencimentoDupPagar')} id="dt_vencimentoDupPagar" className={`${classInput} ${classInputDark} ${dtVencimentoDupPagar != '' ? '' : focusRed} ${dtVencimentoDupPagar === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type="date" min="1900-01-01" max="9999-12-31" autoComplete="off" placeholder=" " value={dtVencimentoDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeDtVencimentoDupPagar} />
                                        <label htmlFor="dt_vencimentoDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dtVencimentoDupPagar != '' ? '' : focusLabelRed}`}>Data Vencimento</label>
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                        <textarea ref={inputsRefsDupPagar.observacaoDupPagar} onKeyDown={(e: React.KeyboardEvent) => handleTabPressDupPagar(e, 'observacaoDupPagar')} id="obsDupPagar" className={`${classInput} ${classInputDark} resize-none`} autoComplete="off" value={observacaoDupPagar} onFocus={handleInputFocusDupPagar} onChange={handleChangeObsDupPagar} />
                                        <label htmlFor="obsDupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                    <div className={`relative col-span-12`}>

                                        <div className={`w-full`}>

                                            <div className={`cursor-default  h-auto`}>

                                                <div className={`w-full ${parcelamentoList.length > 5 ? `pr-[8px]` : ``} `}>

                                                    <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                                        <li className={`h-full border border-white dark:border-slate-600`}>

                                                            <div className={`w-full flex flex-row h-10 font-mono`}>

                                                                <div className={`flex items-center justify-center w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Ações</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>N. Dup</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Série</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Valor</span>
                                                                </div>

                                                                <div className={`flex items-center justify-start w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Vencimento</span>
                                                                </div>

                                                                <div className={`flex items-center justify-start w-[25%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Fornecedor</span>
                                                                </div>

                                                                <div className={`flex items-center justify-start w-[25%] h-full border border-slate-300  dark:border-slate-700`}>
                                                                    <span className={`px-2`}>Observação</span>
                                                                </div>

                                                            </div>

                                                        </li>

                                                    </ul>

                                                </div>

                                            </div>

                                        </div>

                                        <ul className={`w-full overflow-auto h-[300px]`}>

                                            {parcelamentoList.length > 0 &&
                                                parcelamentoList.map((item, index) => {
                                                    return (

                                                        <li key={item.id} tabIndex={0} id={`dupPagar-${index}`} className={`w-full h-auto duration-150 transition-all focus:outline-none border-2 border-white dark:border-slate-600 hover:bg-slate-100 text-slate-600 dark:text-slate-200 dark:hover:bg-slate-500 cursor-pointer`}>

                                                            <div className={`w-full flex flex-row h-[51px] font-mono`}>

                                                                <div className={`flex justify-center items-center w-[10%] break-all border border-slate-300 dark:border-slate-700`}>

                                                                    <ToolTips target={'btn-editar-' + item.id} bgColor='rgb(14, 165, 233)' />

                                                                    <button
                                                                        onClick={() => handleDeleteParcel(item)}
                                                                        data-tooltip-content="Excluir Parcela" data-tooltip-id={'btn-excluir-' + item.id}
                                                                        className={`flex items-center justify-center
                                                                                    text-slate-200 transition-all duration-300
                                                                                    hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                                                                    bg-red-500 `} >
                                                                        <FaTrashAlt size="18px" />
                                                                    </button>
                                                                    <ToolTips target={'btn-excluir-' + item.id} bgColor='rgb(239, 68, 68)' />

                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.num_doc}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.serie}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-start w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{Funcoes.FormatDataPtBr(item.dt_vencimento)}</span>
                                                                </div>

                                                                <div className={`flex items-center w-[25%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.nomeFornecedor}</span>
                                                                </div>

                                                                <div className={`flex items-center w-[25%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.observacao}</span>
                                                                </div>
                                                            </div>

                                                        </li>
                                                    )
                                                })
                                            }

                                        </ul>

                                    </div>


                                </div>

                                {/*
                                 <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Gerar Parcelas</span>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <select id='filterNumParc' className={`${classInput} ${classInputDark}`}  >
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                        <label htmlFor="filterNumParc" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Parcelas</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <input id="dataGerarParcelas" className={`${classInput} ${classInputDark} dark:[color-scheme:dark]`} type="date" placeholder=' ' min="1900-01-01" max="9999-12-31"  />
                                        <label htmlFor="dataGerarParcelas" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <select className={`${classInput} ${classInputDark} dark:[color-scheme:dark]`} >
                                            <option value=""></option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                            <option value="13">13</option>
                                            <option value="14">14</option>
                                            <option value="15">15</option>
                                            <option value="16">16</option>
                                            <option value="17">17</option>
                                            <option value="18">18</option>
                                            <option value="19">19</option>
                                            <option value="20">20</option>
                                            <option value="21">21</option>
                                            <option value="22">22</option>
                                            <option value="23">23</option>
                                            <option value="24">24</option>
                                            <option value="25">25</option>
                                            <option value="26">26</option>
                                            <option value="27">27</option>
                                            <option value="28">28</option>
                                        </select>
                                        <label htmlFor="dataGerarParcelas" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Melhor dia de vencimento</label>
                                    </div>

                                </div>
                                */}

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <button tabIndex={-1} onClick={novoDupPagar} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onFocus={handleInputFocusDupPagar} onClick={handleSalvarDupPagar} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loadingDupPagar && <IoSave size="16px" className='mr-[5px]' />}
                                        {loadingDupPagar &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loadingDupPagar ? ` Lançar Parcela` : `Aguarde`}

                                    </button>

                                </div>

                            </div>
                            { /* Dup. Pagar */}

                            { /* Filtro */}
                            <div className={`${regTrib === 'MEI' ? tabsMei[3]?.active === false ? 'hidden' : 'visible' : tabs[5]?.active === false ? 'hidden' : 'visible'} relative h-[900px] sm:h-[700px] xl:h-[630px]`}>

                                <div className={`grid grid-cols-12 gap-4 py-5 px-2`}>

                                    <div className={`relative col-span-12 sm:col-span-4  xl:col-span-2 2xl:col-span-2`}>
                                        <input ref={inputsRefsFiltro['dtEmissao']} tabIndex={0} onKeyDown={(e) => handle_Tab_Press_Filtro(e, 'dtEmissao')} id='dt_inicial__NF' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} onFocus={searchBoxFocusFiltro} onChange={handleChangeDtInicio} />
                                        <label htmlFor="dt_inicial__NF" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de chegada inicial</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 2xl:col-span-2`}>
                                        <input ref={inputsRefsFiltro['dtChegada']} tabIndex={0} onKeyDown={(e) => handle_Tab_Press_Filtro(e, 'dtChegada')} id='dt_final__NF' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} onFocus={searchBoxFocusFiltro} onChange={handleChangeDtFim} />
                                        <label htmlFor="dt_final__NF" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de chegada final</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <select ref={inputsRefsFiltro['notas']} tabIndex={0} onKeyDown={(e) => handle_Tab_Press_Filtro(e, 'notas')} id="status_NF" className={`${classInput} ${classInputDark} `} value={status} onFocus={searchBoxFocusFiltro} onChange={handleChangeStatus}>
                                            <option value="N" className={`text-slate-900 dark:text-slate-200`}>Não confirmadas</option>
                                            <option value="C" className={`text-slate-900 dark:text-slate-200`}>Confirmadas</option>
                                        </select>
                                        <label htmlFor="status_NF" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Notas</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 xl:col-span-4`}>

                                        <div ref={inputsRefsFiltro['fornecedorFiltro']} tabIndex={0} onKeyDown={(e) => handle_Tab_Press_Filtro(e, 'fornecedorFiltro')} />
                                        <SearchBox
                                            dataList={fornecedoresFilter}
                                            idRegistro={idFornecedorFilter}
                                            label="Fornecedor"
                                            componentId='fornFiltro'
                                            visibleTAB={visibleSearchBoxFornFiltro}
                                            clearDataClick={handleClearFornSelecionadoFilter}
                                            setDataClick={handleClickSelectFornecedorFilter}
                                            filterDataClick={handleFilterFornecedoresFilter}
                                            clicado={clickSearchBoxFornFiltro}
                                        />

                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} `} onClick={filterNF} >
                                            <span className={`w-full h-full flex justify-center items-center`}>
                                                {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                                {loading &&
                                                    <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                    </div>
                                                }
                                                {!loading && `Pesquisar`} {loading && `Aguarde`}
                                            </span>
                                        </button>
                                    </div>

                                    <div className={`relative col-span-12 overflow-x-hidden hover:overflow-x-auto overflow-y-hidden py-2`}>

                                        <GridEntradaNota
                                            NFList={NFList}
                                            buscarDadosNF={buscarDadosNF}
                                            confirmarNota={confirmarNota}
                                            habilitarNF={habilitarNF}
                                            visualizarNF={visualizarNF}
                                            tipo={status === "N" ? "N" : "C"}
                                            relatorio={relatorio}/>

                                    </div>

                                </div>



                            </div>
                            { /* Filtro */}

                            { /* Conteúdo */}

                        </div>

                    </div>

                </div>

                <ModalLancaItemNF
                    visible={visibleModalItens}
                    idNF={idNF}
                    nitemNF={nitemNF}
                    idForn={idFornecedor}
                    attributes={attributesNFEntrada}
                    regimeTributario={regimeTributario}
                    loading={false}
                    handleModalClose={fecharModalLancarItem}
                    buttonConfirmClick={handleConfirmCadItem}
                />

                <ModalExcluirDados
                    show={modalShow}
                    isLoading={loadingExcluir}
                    message={`Deseja exluir o item - ${nomeExcluir || ''}?`}
                    closeModalEvent={fecharModalExclusao}
                    excluirEvent={handleExcluir}
                    fecharModalEvent={buttonFecharModalExcluirDados}
                />

            </div>

        </Template>
    )

}